/** Action kind in the scenarion for payment tasks */
export enum PaymentScenarionActionMethodEnum {
  /** Add new approvers in brs task */
  ADD_APPROVER = 'ADD_APPROVER',
}
